/**
 * MemorialPageButton — creates (or opens) the shareable /memorial/{slug}
 * page for a departed tree member or an existing Celebrate memorial.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Flower2, Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function MemorialPageButton({ treeId, memberId, memorialSlug, className = "wofy-btn-ghost text-sm", children, testId = "memorial-page-btn" }) {
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const go = async () => {
    if (!user) {
      toast.info("Sign in to create a shareable memorial page.");
      navigate(`/login?next=${encodeURIComponent(window.location.pathname)}`);
      return;
    }
    setBusy(true);
    try {
      const url = memorialSlug
        ? `/memorials/${memorialSlug}/memorial-page`
        : `/family-trees/${treeId}/members/${memberId}/memorial-page`;
      const { data } = await http.post(url, {});
      navigate(`/memorial/${data.page.slug}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't open the memorial page.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={go} disabled={busy} className={className} data-testid={testId}
      title="Open a beautiful, publicly shareable memorial page">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Flower2 className="w-4 h-4" />}
      {children || "Memorial Page"}
    </button>
  );
}
